<template>
  <div>
    <Breadcrumbs main="matchTx.dashboard" title="matchTx.header" />
    <b-container fluid>
      <h2 class="mb-1 mt-4 f-w-600">{{ $t('matchTx.header') }}</h2>
      <div>
          <div class="d-flex flex-row justify-content-between mx-1"> 
            <div>
              <h3 class="mb-1 mt-1 ml-3 f-w-600">{{ $t('matchTx.reqrReceiver') }}</h3> 
            </div>
            <div>
              <b-dropdown id="dropdown-left" size="md" :text=" $t('matchTx.exportData')" variant="outline-primary" class="m-2">
                <b-dropdown-text style="width: 300px;">
                  {{ $t('matchTx.exportDataMsg') }}
                </b-dropdown-text>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item class="m-2" style="font-size: 20px;"  @click="back7days">{{ $t('matchTx.back7days') }}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item class="m-2" style="font-size: 20px;"  @click="back30days" >{{ $t('matchTx.back30days') }}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item  class="m-2"  style="font-size: 20px;" @click="inYear">{{ $t('matchTx.inYear') }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <div v-if="isGenerating" class="ml-3" style="margin-top: 10px;">
              <progress :value="progressValue" max="100"></progress>
              <span class="text-danger" style="font-size: 18px;">EIR Generating Progress => {{ progressValue }} %</span>
            </div>          
          </div>
          <b-row>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.sort')"
                label-for="sort-by-select-reqr"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedbyReqr }"
              >
                <b-input-group size="lg">
                  <b-form-select
                    id="sort-by-select-reqr"
                    v-model="sortByReqr"
                    :options="sortOptionsReqr"
                    :aria-describedby="ariaDescribedbyReqr"
                    class="w-70 text-info"
                  >
                    <template #first>
                      <option value="">-- none --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDescReqr"
                    :disabled="!sortByReqr"
                    :aria-describedby="ariaDescribedbyReqr"
                    size="lg"
                    class="w-30 text-info"
                  >
                    <option :value="false">{{$t('matchTx.asc')}}</option>
                    <option :value="true">{{$t('matchTx.desc')}}</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.initSort')"
                label-for="initial-sort-select-reqr"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-form-select
                  id="initial-sort-select-reqr"
                  v-model="sortDirectionReqr"
                  :options="['asc', 'desc', 'last']"
                  size="lg"
                  class="text-info"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.filter')"
                label-for="filter-input-reqr"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input-reqr"
                    v-model="filterReqr"
                    type="search"
                    :placeholder="$t('matchTx.typeToSearch')"
                    class="text-info"
                    style="font-size: 18px;"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button size="md" variant="primary" :disabled="!filterReqr" @click="filterReqr = ''">
                      {{ $t('matchTx.clear') }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                v-model="sortDirectionReqr"
                :label="$t('matchTx.filterOn')"
                :description= "$t('matchTx.uncheck')"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedbyReqr }"
              >
                <b-form-checkbox-group
                  v-model="filterOnReqr"
                  :aria-describedby="ariaDescribedbyReqr"
                  class="mt-1 text-info"
                  plain
                >
                  <b-form-checkbox value="agent">{{ $t('matchTx.agent') }}</b-form-checkbox>
                  <b-form-checkbox value="bkgId">{{ $t('matchTx.bkgId') }}</b-form-checkbox>
                  <b-form-checkbox value="contNo">{{ $t('matchTx.contNo') }}</b-form-checkbox>     
                  <b-form-checkbox value="contSize">{{ $t('matchTx.contSize') }}</b-form-checkbox>   
                  <b-form-checkbox value="contType">{{ $t('matchTx.contType') }}</b-form-checkbox>   
                  <b-form-checkbox value="contGrade">{{ $t('matchTx.contGrade') }}</b-form-checkbox>
                  <b-form-checkbox value="sealNo">{{ $t('matchTx.sealNo') }}</b-form-checkbox>  
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="row justify-content-start ml-2">
            <feather 
                @click="refreshMatchTx" 
                class="text-primary" 
                type="refresh-cw"  
                size="25" 
                v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
              </feather>  
                <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
                <span class="text-primary"> {{ asOf }} </span>   
            </div>
        <b-table
          sticky-header
          show-empty
          bordered
          responsive
          sort-icon-left
          stacked="md"
          :busy="isBusy"
          :sort-by.sync="sortByReqr"
          :sort-desc.sync="sortDescReqr"
          :sort-direction="sortDirectionReqr"
          :filter="filterReqr"
          :filter-included-fields="filterOnReqr"
          :items="itemsReqr"
          :fields="fieldsReqr"
          :current-page="currentPageReqr"
          :per-page="perPageReqr"
          @filtered="onFilteredReqr"
        >
        <template #thead-top="">
        <b-tr>
          <b-th colspan="2"><span class="sr-only">mTxId and BkgId</span></b-th>
          <b-th variant="info" colspan="7" class="tableInfo">{{ $t('matchTx.contInfo') }}</b-th>
          <b-th colspan="2"><span class="sr-only">sealShip</span></b-th>
          <b-th variant="danger" colspan="3" class="tableInfo">{{ $t('matchTx.jobStatusMtx') }}</b-th>
          <b-th colspan="2"><span class="sr-only"></span></b-th>
          <b-th variant="success" colspan="4" class="tableInfo">{{ $t('release.header') }}</b-th>
          <b-th variant="primary" colspan="4" class="tableInfo">{{ $t('require.header') }}</b-th>
          <b-th variant="warning" colspan="3" class="tableInfo">{{ $t('matchTx.transportation') }}</b-th>
        </b-tr>
      </template>
          <template #cell(addressReqr)="row" >
            <b-button size="sm"  v-b-popover.hover.top="row.item.contReqrAddress" variant="outline-info">
                {{ $t('matchTx.reqr') }}
            </b-button>
          </template>
          <template #cell(addressRels)="row" >
            <b-button  size="sm" v-b-popover.hover.top="row.item.contRelsAddress" variant="outline-info">
                {{ $t('matchTx.rels') }}
            </b-button>
          </template>
          <template #cell(jbStatusReqr)="row" >
            <b-button  size="sm" @click="openModalJbStatusReqr(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('matchTx.jobStatusDetails')">
              {{ $t(`matchTx.${row.item.jbReqr}`) }}
            </b-button>
          </template>
          <template #cell(transStatusReqr)="row" >
            <b-button  size="sm" @click="openModalTransStatus(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('matchTx.transStatusDetails')">
              {{ $t(`matchTx.${row.item.transStatus}`) }}
            </b-button>
          </template>
          <template #cell(contImageReqr)="row" >
            <b-button  size="sm" @click="openModalImageReqr(row.item, row.index, $event.target )" v-b-popover.hover.top="`${$t('container.contId')} : ${row.item.contId}`">
              {{ row.item.contNo == 'Dummy' || row.item.contNo == 'dummy' || row.item.contNo == '' ? `${$t('container.dummy')}` : row.item.contNo }}
            </b-button>
          </template>
          <template #cell(transCompNameReqr)="row" >
            <b-button  size="sm" @click="openModalTransCompReqr(row.item, row.index, $event.target )">
                {{ row.item.transCompId }}
            </b-button>
          </template>
          <template #cell(actReqr)="row" >
            <b-button class="mb-1" v-show="row.item.actReqr.cancel" size="sm" variant="danger" @click="actReqrCancel(row.item , 1.1)" v-b-popover.hover.top="$t('matchTx.cancelMsg')">
              {{ $t('matchTx.cancel') }}
            </b-button>
            <b-button class="mb-1" v-show="row.item.actReqr.accept" size="sm" variant="success" @click="actReqrAccept(row.item)" v-b-popover.hover.top="$t('matchTx.acceptMsg')">
              {{ $t('matchTx.accept') }}
            </b-button>
            <b-button class="mb-1" v-show="row.item.actReqr.reject" size="sm" variant="danger" @click="actReqrReject(row.item , 1.2)" v-b-popover.hover.top="$t('matchTx.rejectMsg')">
              {{ $t('matchTx.reject') }}
            </b-button>
            <div>
              <b-button-group>
                <b-button class="mb-1" v-show="row.item.actReqr.attachSeal" size="sm" variant="info" @click="actReqrAttachSeal(row.item)" v-b-popover.hover.top="$t('matchTx.attachSealMsg')">
                  {{ $t('matchTx.attachSeal') }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actReqr.terminate && (row.item.transStatus == 'waitAccept' || row.item.transStatus == 'reject')" size="sm" variant="danger" @click="actReqrTerminate(row.item)" v-b-popover.hover.top="$t('matchTx.terminateMsg')">
                  {{ $t('matchTx.terminate') }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actReqr.transfer" size="sm" variant="warning" @click="actReqrTransfer(row.item)" v-b-popover.hover.top="$t('matchTx.transferMsg')">
                  {{ $t('matchTx.transfer') }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actReqr.updateSeal" size="sm" variant="warning" @click="actReqrUpdateSeal(row.item)" v-b-popover.hover.top="$t('matchTx.updateSealMsg')">
                  {{ $t('matchTx.updateSeal') }}
                </b-button>    
                <b-button class="mb-1" v-show="row.item.actReqr.shore && row.item.shoreStatus == 'waitRequest'" size="sm" variant="primary" @click="actShore(row.item)" v-b-popover.hover.top="$t('matchTx.shoreMsg')">
                  {{ $t('matchTx.shore') }}
                </b-button>                      
              </b-button-group>
            </div> 
            <div>
              <b-button-group>
                <b-button class="mb-1" v-show="row.item.actReqr.eirRels" size="sm" variant="outline-info" @click="actEirRels(row.item)" v-b-popover.hover.top="$t('matchTx.eirRelsMsg')" >
                  {{ isGenerating && actEirAtLoc == 'rels'? $t('matchTx.eirRelsGentng') : $t('matchTx.eirRels')  }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actReqr.eirRecv" size="sm" variant="outline-info" @click="actEirRecv(row.item)" v-b-popover.hover.top="$t('matchTx.eirRecvMsg')">
                  {{ isGenerating && actEirAtLoc == 'recv'? $t('matchTx.eirRecvGentng') : $t('matchTx.eirRecv')  }}
                </b-button>  
                <b-button class="mb-1" v-show="row.item.actReqr.dispRels" size="sm" variant="info" @click="actDispRels(row.item)" v-b-popover.hover.top="$t('matchTx.dispRelsMsg')" >
                  {{ $t('matchTx.dispRels') }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actReqr.dispRecv" size="sm" variant="info" @click="actDispRecv(row.item)" v-b-popover.hover.top="$t('matchTx.dispRecvMsg')" >
                  {{ $t('matchTx.dispRecv') }}
                </b-button>                       
              </b-button-group>
            </div>
          <div>
            <b-button-group>    
              <b-button class="mb-1" v-show="row.item.actReqr.shore && row.item.shoreStatus == 'waitAccept'" size="sm" variant="danger" @click="actShoreCancel(row.item)" v-b-popover.hover.top="$t('matchTx.shoreCancelMsg')">
                {{ $t('matchTx.shoreCancel') }}
              </b-button>
              <b-button class="mb-1" v-show="row.item.actReqr.shore && (row.item.shoreStatus == 'reject' || row.item.shoreStatus == 'cancel' || row.item.shoreStatus == 'waitAccept') " size="sm" variant="mute"  v-b-popover.hover.top="$t('matchTx.shoreEditMsg')">
                {{ $t('matchTx.shoreEdit') }}
              </b-button>              
            </b-button-group>
          </div>
            <b-button class="mb-1" v-show="row.item.jbReqr == 'shipsRej'" size="sm" variant="warning" @click="openModalViewShipsRejectReqr(row.item, row.index, $event.target )">
              {{ $t('matchTx.viewShipsReject') }}
            </b-button>
          </template>
          <template #empty>
              <h5>{{ $t('reuse.noRecord') }}</h5>
          </template>
        </b-table>
        <b-row>
          <div class="row col-sm-4 ">
            <b-col class="my-1 ml-3">
              <b-pagination
                v-model="currentPageReqr"
                :total-rows="totalRowsReqr"
                :per-page="perPageReqr"
                align="fill"
                class="my-0"
              ></b-pagination>
            </b-col>   
            <b-col sm="3" md="6" class="my-1">
              <b-form-group
                :label= "$t('require.perPage')"
                label-for="per-page-select"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-form-select
                  id="per-page-select"
                  v-model="perPageReqr"
                  :options="pageOptionsReqr"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </div>
        </b-row>
        <!-- Info modal Reqr Attch Seal-->
        <div>
          <!-- <b-button @click="showSealNoModal=true" variant="primary">Show Modal</b-button> -->
          <b-modal
            id="reqrEir-modal" 
            :title="this.$t('matchTx.eirTitleNoInsp')"
            v-model="showEirModal"
            header-bg-variant="warning"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            size="lg"
            hide-footer
          >
          <h3 class="text-white bg-warning text-center">{{ $t('matchTx.noInspResult') }}</h3>
            <b-form inline>
              <label class="mx-2">{{$t('matchTx.refNo')}}</label> 
              <span> {{ selected_mTxId }}-EIR</span> 
            </b-form>
            <b-col>
              <b-form inline>
                <label class="mx-2" >{{ $t('matchTx.compNameLocalRelsEir') }}</label>
                <b-form-input class="text-primary"
                  v-model="selectedCompNameLocalRels"
                ></b-form-input>                  
              </b-form>
              <b-input-group prepend="@" class="mb-4 mr-sm-2 mb-sm-0">
                <b-form-input class="text-primary"
                  v-model="selectedContRelsAddress"
                ></b-form-input>                  
              </b-input-group>                
            </b-col>
            <b-col>
              <b-form inline>
                <label class="mx-2" >{{ $t('matchTx.compNameLocalReqrEir') }}</label>
                <b-form-input class="text-primary"
                  v-model="selectedCompNameLocalReqr"
                ></b-form-input>                  
              </b-form>
              <b-input-group prepend="@" class="mb-2 mr-sm-2 mb-sm-0">
                <b-form-input class="text-primary"
                  v-model="selectedContReqrAddress"
                ></b-form-input>                  
              </b-input-group>
            </b-col>
            <div class="divider my-2"> </div>
            <b-row>
              <b-col>
                <h5 class="mx-2">{{$t('matchTx.contNoEir')}} : </h5> 
                <span class="text-primary ml-2"> {{ selectedContNo }}</span> 
              </b-col>
              <b-col>
                <h5 class="mx-2">{{$t('matchTx.typeSize')}} : </h5> 
                <span class="text-primary ml-2"> {{selectedContType}} : {{ selectedContSize }}</span> 
              </b-col>

              <b-col>
                <h5 class="mx-2">{{$t('matchTx.tareEir')}} : </h5> 
                <span class="text-primary ml-2"> {{selectedContTare}} </span> 
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <h5 class="mx-2">{{$t('matchTx.bkgIdEir')}} : </h5> 
                <span class="text-primary ml-2"> {{ selectedBkgId }}</span> 
              </b-col>
              <b-col>
                <h5 class="mx-2">{{$t('matchTx.agentEir')}} : </h5> 
                <span class="text-primary ml-2"> {{selectedAgent}} </span> 
              </b-col>
              <b-col>
                <h5 class="mx-2">{{$t('matchTx.sealNoEir')}} : </h5> 
                <span class="text-primary ml-2"> {{selectedSealNo}} </span> 
              </b-col>              
            </b-row>
            <div class="divider my-2"> </div>
            <b-row>
              <b-col class="ml-2">
                <label class="mx-2 text-danger f-w-800" style="font-size: 16px;" >{{$t('matchTx.remark')}} : </label> 
                <b-form-input class="text-primary"
                  v-model="remark"
                ></b-form-input> 
              </b-col>
            </b-row>
            <b-col>
              <b-form inline>
                <label class="mx-2" >{{ $t('matchTx.inspector') }}</label>
                <b-form-input class="text-primary"
                  v-model="selectedCompNameLocalInsp"
                ></b-form-input>                  
              </b-form>
              <b-input-group prepend="@" class="mb-4 mr-sm-2 mb-sm-0">
                <b-form-input class="text-primary"
                  v-model="selectedContInspAddress"
                ></b-form-input>                  
              </b-input-group>               
            </b-col>
            <div class="divider"> </div>
            <div >
              <b-button
                variant="primary"
                size="md"
                class="float-right"
                @click="clickEir_Issue"
              >
              {{ $t('matchTx.issue') }}
              </b-button>              
              <b-button
                variant="warning"
                size="md"
                class="float-right"
                @click="clickEir_NO"
              >
                {{ $t('matchTx.no') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal
            id="dispRels-modal" 
            :title="$t('matchTx.dispModalTitle')"
            v-model="showDispRelsModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            hide-footer
          >
            <div class="m-2">
                <h4 class="text-primary">{{ $t('matchTx.dispRelsMsg') }}</h4>    
                <div class="gradient-yg">
                  <div class="row m-2">
                    <span class="text-dark"> {{  $t('matchTx.contNo') }} :</span>
                    <span class="text-primary ml-2"> {{ selectedEirItem.contNo}}</span>
                  </div>
                  <div class="row m-2">
                    <span class="text-dark"> {{  $t('approvedTrans.sumResult') }} :</span>
                    <!-- <span class="text-primary ml-2"> {{  $t(`approvedTrans.${selectedEirItem.sumResult}`)}}</span> -->
                    <span class="text-primary ml-2"> {{  $t('approvedTrans.' + (selectedEirItem.sumResult || 'passed')) }}</span>
                  </div>
                  <div class="row m-2">
                    <span class="text-dark"> {{  $t('approvedTrans.remark') }} :</span>
                    <span class="text-primary ml-2"> {{ selectedEirItem.sum_rem }}</span>
                  </div>                 
                </div>
                <span> {{ $t('matchTx.dispInfo1') }}</span>
                <h3 class="my-3 text-danger"> {{ $t('matchTx.reminder') }} </h3>
                <span class="gradient-wp mb-2"> {{ $t('matchTx.dispInfo2') }}</span>
            </div>
            <div class="w-100">
              <b-button
                variant="danger"
                size="md"
                class="float-right"
                @click="dispRelsReject"
              >
              {{ $t('approvedTrans.reject') }}
              </b-button> 
              <b-button
                variant="success"
                size="md"
                class="float-right mx-2"
                @click="dispRelsAccept"
              >
              {{ $t('approvedTrans.pass') }}
              </b-button>              
              <b-button
                variant="warning"
                size="md"
                class="float-right"
                @click="disp_NO"
              >
                {{ $t('matchTx.no') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal
            id="dispRecv-modal" 
            :title="$t('matchTx.dispModalTitle')"
            v-model="showDispRecvModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            hide-footer
          >
          <div class="m-2">
                <h4 class="text-primary">{{ $t('matchTx.dispRelsMsg') }}</h4>    
                <div class="gradient-yg">
                  <div class="row m-2">
                    <span class="text-dark"> {{  $t('matchTx.contNo') }} :</span>
                    <span class="text-primary ml-2"> {{ selectedEirItem.contNo}}</span>
                  </div>
                  <div class="row m-2">
                    <span class="text-dark"> {{  $t('approvedTrans.sumResult') }} :</span>
                    <!-- <span class="text-primary ml-2"> {{  $t(`approvedTrans.${selectedEirItem.sumResult}`)}}</span> -->
                    <span class="text-primary ml-2"> {{  $t('approvedTrans.' + (selectedEirItem.sumResult || 'passed')) }}</span>
                  </div>
                  <div class="row m-2">
                    <span class="text-dark"> {{  $t('approvedTrans.remark') }} :</span>
                    <span class="text-primary ml-2"> {{ selectedEirItem.sum_rem }}</span>
                  </div>                 
                </div>
                <span> {{ $t('matchTx.dispInfo1') }}</span>
                <h3 class="my-3 text-danger"> {{ $t('matchTx.reminder') }} </h3>
                <span class="gradient-wp mb-2"> {{ $t('matchTx.dispInfo2') }}</span>
            </div>
            <div class="w-100">
              <b-button
                variant="danger"
                size="md"
                class="float-right"
                @click="dispRecvReject"
              >
              {{ $t('approvedTrans.reject') }}
              </b-button> 
              <b-button
                variant="success"
                size="md"
                class="float-right mx-2"
                @click="dispRecvAccept"
              >
              {{ $t('approvedTrans.pass') }}
              </b-button>              
              <b-button
                variant="warning"
                size="md"
                class="float-right"
                @click="disp_NO"
              >
                {{ $t('matchTx.no') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal
            id="shore-modal" 
            :title="$t('matchTx.shoreModalTitle')"
            v-model="showShoreModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            hide-footer
          >
            <div class="form-row">
                <h3 class="text-primary">{{ $t('matchTx.shoreData') }}</h3>              
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="cargoDesc" class="col-form-label text-primary f-w-600">{{ $t('matchTx.cargoDesc') }}</label>
                        <input class="form-control" id="cargoDesc" v-model="cargoDesc" type="text" :placeholder="$t('matchTx.cargoDescPh') ">
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="cargoOwner" class="col-form-label text-primary f-w-600">{{ $t('matchTx.cargoOwner') }}</label>
                        <input class="form-control" id="cargoOwner" v-model="cargoOwner" type="text" :placeholder="$t('matchTx.cargoOwnerPh') ">
                    </div>
                </div>                
                <div class="col-md-6">
                  <div class="form-group">
                      <label for="destPort" class="col-form-label text-primary f-w-600">{{ $t('matchTx.destPort') }}</label>
                      <input class="form-control" id="destPort" v-model="destPort" type="text" :placeholder="$t('matchTx.destPortPh')">
                  </div>
                </div>                
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="cargoWeight" class="col-form-label text-primary f-w-600">{{ $t('matchTx.cargoWeight') }}</label>
                        <input class="form-control" id="cargoWeight" v-model="cargoWeight" type="number" :placeholder="$t('matchTx.cargoWeightPh') ">
                    </div>
                </div>
            </div>
            <div class="w-100">
              <b-button
                variant="primary"
                size="md"
                class="float-right"
                @click="clickShore_OK"
              >
              {{ $t('truck.ok') }}
              </b-button>              
              <b-button
                variant="warning"
                size="md"
                class="float-right"
                @click="clickShore_NO"
              >
                {{ $t('matchTx.no') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal
            :id="actReqrAttachSealModal.id" 
            :title="actReqrAttachSealModal.title"
            v-model="showSealNoModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            hide-footer
          >
            <b-row class="mb-1">
              <b-col cols="4">{{ $t('matchTx.selSealNo') }}</b-col>
              <b-col>
                <v-select
                  v-model="selectedSealNo"
                  :options="sealNos"
                  :placeholder="$t('surcharge.plsSelect')"
                ></v-select>
              </b-col>
            </b-row>
            <div class="w-100">
              <span class="float-left">{{$t('matchTx.sealNo')}} : </span> <span> {{ selectedSealNo }}</span> 
              <b-button
                variant="primary"
                size="sm"
                class="float-right"
                @click="clickAttachSeal_OK"
              >
              {{ $t('truck.ok') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal
            :id="actReqrUpdateSealModal.id" 
            :title="actReqrUpdateSealModal.title"
            v-model="showUpdateSealNoModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            hide-footer
          >
            <b-row class="mb-1">
              <b-col cols="4">{{ $t('matchTx.selSealNo') }}</b-col>
              <b-col>
                <v-select
                  v-model="selectedSealNo"
                  :options="sealNos"
                ></v-select>
              </b-col>
            </b-row>
            <div class="w-100">
              <span class="float-left">{{$t('matchTx.sealNo')}} : </span> <span> {{ selectedSealNo }}</span> 
              <b-button
                variant="primary"
                size="sm"
                class="float-right"
                @click="clickUpdateSeal_OK"
              >
              {{ $t('truck.ok') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal
            :id="actReqrTransferModal.id" 
            :title="actReqrTransferModal.title"
            v-model="showTransferModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            hide-footer
          >
            <b-row class="mb-1">
              <b-col cols="4">{{ $t('matchTx.selBkgId') }}</b-col>
              <b-col>
                <b-form-select
                  v-model="selectedBkgId"
                  :options="bkgIds"
                ></b-form-select>
              </b-col>
            </b-row>
            <div class="w-100">
              <span class="float-left">{{$t('matchTx.bkgId')}} : </span> <span> {{ selectedBkgId }}</span> 
              <b-button
                variant="primary"
                size="sm"
                class="float-right"
                @click="clickBkgId_OK"
              >
              {{ $t('truck.ok') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal id="jbStatusModalReqr" :title="$t('matchTx.jobStatusDetails')" size="lg" ok-only @hide="resetInfoModalJbReqr">
            <div v-for="(item , index) in jbStatusReqr" :key="index" class="my-loop-item">
             <div class="row">
              <h4 class="ml-2 my-1">&gt;</h4>
              <span class="ml-2 my-1">{{ $moment(item.timestamp).format("DD-MM-YY @ HH:mm") }}</span>
              <span class="ml-2 my-1"> {{ $t(`jbReqr.${item.jbReqr}`)  }}</span>
             </div>
            </div>

          </b-modal>
          <b-modal id="jbStatusModalRels" :title="$t('matchTx.jobStatusDetails')" size="lg" ok-only @hide="resetInfoModalJbRels">
            <div v-for="(item , index) in jbStatusRels" :key="index" class="my-loop-item">
             <div class="row">
              <h4 class="ml-2 my-1">&gt;</h4>
              <span class="ml-2 my-1 text-fw-bold ">{{ $moment(item.timestamp).format("DD-MM-YY @ HH:mm") }}</span>
              <span class="ml-2 my-1"> {{ $t(`jbRels.${item.jbRels}`)  }}</span>
             </div>
            </div>
          </b-modal>
          <b-modal id="transStatusModal" :title="$t('matchTx.transStatusDetails')" size="lg" ok-only @hide="resetInfoModalTransStatus">
            <div v-for="(item , index) in transStatus" :key="index" class="my-loop-item">
              <div class="row">
                <h4 class="ml-2 my-1">&gt;</h4>
                <span class="ml-2 my-1 text-fw-bold ">{{ $moment(item.timestamp).format("DD-MM-YY @ HH:mm") }}</span>
                <span class="ml-2 my-1"> {{ $t(`transStatus.${item.transStatus}`)  }}</span>
              </div>
            </div>
            <div  class="gradient-wb"> 
              <h3 class="mt-2 text-dark">{{ $t('transport.transBooking') }}</h3>
              <div v-if="trans == ''"> 
                <h3 class=text-primary>{{ $t('transport.noTransport') }} : </h3>
              </div>
              <div v-else> 
                <div class="row m-2">
                  <h4 class="text-primary">{{ $t('truck.licensePlate') }} : </h4>
                  <span class="text-info ml-2"> {{  trans.licensePlate }}</span>
                </div>   
                <div class="row m-2">
                  <h4 class="text-primary">{{ $t('transport.truckStartAtRels') }} : </h4>
                  <span class="text-info ml-2"> {{  $moment(trans.startAt).format("DD-MM-YY @ HH:mm") }}</span>
                </div>                   
              </div>
            </div>
          </b-modal>
            <!-- Info modal Container Image Reqr-->
          <b-modal id="contModalReqr" :title="modalTitleReqr" ok-only @hide="resetInfoModalReqr">
            <div class="row my-2 ml-1">
              <h5 class="text-primary ml-3"> {{ $t('container.contId') }} : </h5>               
              <span class="text-primary ml-2">{{ modalContIdReqr }}</span>                  
            </div>
            <div class="gradient-yg p-1" >
                <div class="dashboard">
                    <div class="image-scroll-container">
                        <div class="image-scroll" ref="scrollContainer">
                            <div
                            class="image-item"
                            v-for="(image, index) in imageUriModalReqr"
                            :key="image.id"
                            >
                            <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                            <span class="image-counter">{{ index + 1 }} of {{ imageUriModalReqr.length }}</span>
                            </div>
                            <div v-if="imageUriModalReqr.length === 0" class="no-images">
                            {{$t('approvedTrans.noImageYet') }}
                            </div>
                        </div>
                        <div class="scroll-controls" v-if="imageUriModalReqr.length > 1">
                            <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                            <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                            <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                            <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                        </div>
                    </div>                        
                </div>
            </div>
          </b-modal>
            <!-- Info modal Container Image Rels-->
          <b-modal id="contModalRels" :title="modalTitleRels" ok-only @hide="resetInfoModalRels">
            <div class="row my-2 ml-1">
              <h5 class="text-primary ml-2"> {{ $t('container.contId') }} : </h5>               
              <span class="text-primary ml-2">{{ modalContIdRels }}</span>                  
            </div>
            <div class="gradient-yg p-1" >
                <div class="dashboard">
                    <div class="image-scroll-container">
                        <div class="image-scroll" ref="scrollContainer">
                            <div
                            class="image-item"
                            v-for="(image, index) in imageUriModalRels"
                            :key="image.id"
                            >
                            <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                            <span class="image-counter">{{ index + 1 }} of {{ imageUriModalRels.length }}</span>
                            </div>
                            <div v-if="imageUriModalRels.length === 0" class="no-images">
                            {{$t('approvedTrans.noImageYet') }}
                            </div>
                        </div>
                        <div class="scroll-controls" v-if="imageUriModalRels.length > 1">
                            <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                            <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                            <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                            <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                        </div>
                    </div>                        
                </div>
            </div>
          </b-modal>
          <b-modal id="viewShipsRejectModalReqr" :title="$t('matchTx.viewShipsRejectTitle')" ok-only @hide="resetInfoModalShipsRejectReqr">
            <div class="me-5" style=" width:30rem">
                <h6 class="me-5"> {{ shipsRejectRemarkReqr }}</h6>
            </div>
          </b-modal>
          <b-modal id="viewShipsRejectModalRels" :title="$t('matchTx.viewShipsRejectTitle')" ok-only @hide="resetInfoModalShipsRejectRels">
            <div class="me-5" style=" width:30rem">
                <h6 class="me-5"> {{ shipsRejectRemarkRels   }}</h6>
            </div>
          </b-modal>
          <b-modal id="transCompModalRels" header-text-variant="primary" :title="$t('matchTx.transComp')" ok-only @hide="resetInfoModalTransCompRels">
            <div class="me-5" style=" width:30rem">
                <h6 class="me-5"> {{ transCompInfoRels.compNameLocal }}</h6>
                <h6 class="me-5"> {{ transCompInfoRels.compNameEng }}</h6>
                <div class=" row ml-2"> 
                  <h5 class="text-primary"> {{ $t('company.contactEmail') }} :</h5> 
                  <span class="ml-3 text-info"> {{ transCompInfoRels.contactEmail }}</span>                  
                </div>
                <div class=" row ml-2 mt-2"> 
                  <h5 class="text-primary"> {{ $t('company.contactPhone') }} :</h5> 
                  <span class="ml-3 text-info"> {{ transCompInfoRels.contactPhone }}</span>                  
                </div>
                <div class="ml-2 mt-2"> 
                  <h5 class="text-primary"> {{ $t('company.address') }} :</h5> 
                  <h6 class="text-info"> {{ transCompInfoRels.compAddress }}</h6>                  
                </div>
            </div>
          </b-modal>
          <b-modal id="transCompModalReqr" header-text-variant="primary" :title="$t('matchTx.transComp')" ok-only @hide="resetInfoModalTransCompReqr">
            <div class="me-5" style=" width:30rem">
                <h6 class="me-5"> {{ transCompInfoReqr.compNameLocal }}</h6>
                <h6 class="me-5"> {{ transCompInfoReqr.compNameEng }}</h6>
                <div class=" row ml-2"> 
                  <h5 class="text-primary"> {{ $t('company.contactEmail') }} :</h5> 
                  <span class="ml-3 text-info"> {{ transCompInfoReqr.contactEmail }}</span>                  
                </div>
                <div class=" row ml-2 mt-2"> 
                  <h5 class="text-primary"> {{ $t('company.contactPhone') }} :</h5> 
                  <span class="ml-3 text-info"> {{ transCompInfoReqr.contactPhone }}</span>                  
                </div>
                <div class="ml-2 mt-2"> 
                  <h5 class="text-primary"> {{ $t('company.address') }} :</h5> 
                  <h6 class="text-info"> {{ transCompInfoReqr.compAddress }}</h6>                  
                </div>
            </div>
          </b-modal>
        </div>

      </div>
      <div class="divider"> </div>
      <div>
        <b-row>
          <h3 class="my-1 ml-4 f-w-600">{{ $t('matchTx.relsProposer') }}</h3> 
          <b-row>
            <b-col lg="6" class="my-1">
              <b-form-group
                :label="$t('matchTx.sort')"
                label-for="sort-by-select-rels"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedbyRels }"
              >
                <b-input-group size="lg">
                  <b-form-select
                    id="sort-by-select-rels"
                    v-model="sortByRels"
                    :options="sortOptionsRels"
                    :aria-describedby="ariaDescribedbyRels"
                    class="w-70 text-info"
                  >
                    <template #first>
                      <option value="">-- none --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDescRels"
                    :disabled="!sortByRels"
                    :aria-describedby="ariaDescribedbyRels"
                    size="lg"
                    class="w-30 text-info"
                  >
                    <option :value="false">{{$t('matchTx.asc')}}</option>
                    <option :value="true">{{$t('matchTx.desc')}}</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="my-1">
              <b-form-group
                :label="$t('matchTx.initSort')"
                label-for="initial-sort-select-rels"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-form-select
                  id="initial-sort-select-rels"
                  v-model="sortDirectionRels"
                  :options="['asc', 'desc', 'last']"
                  size="lg"
                  class="text-info"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="my-1">
              <b-form-group
                :label="$t('matchTx.filter')"
                label-for="filter-input-rels"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input-rels"
                    v-model="filterRels"
                    type="search"
                    :placeholder="$t('matchTx.typeToSearch')"
                    class="text-info"
                    style="font-size: 18px;"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button size="md" variant="primary" :disabled="!filterRels" @click="filterRels = ''">
                      {{ $t('matchTx.clear') }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="my-1">
              <b-form-group
                v-model="sortDirectionRels"
                :label="$t('matchTx.filterOn')"
                :description= "$t('matchTx.uncheck')"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedbyRels }"
              >
                <b-form-checkbox-group
                  v-model="filterOnRels"
                  :aria-describedby="ariaDescribedbyRels"
                  class="mt-1 text-info"
                  plain
                >
                  <b-form-checkbox value="agent">{{ $t('matchTx.agent') }}</b-form-checkbox>
                  <b-form-checkbox value="bkgId">{{ $t('matchTx.bkgId') }}</b-form-checkbox>
                  <b-form-checkbox value="contNo">{{ $t('matchTx.contNo') }}</b-form-checkbox>     
                  <b-form-checkbox value="contSize">{{ $t('matchTx.contSize') }}</b-form-checkbox>   
                  <b-form-checkbox value="contType">{{ $t('matchTx.contType') }}</b-form-checkbox>   
                  <b-form-checkbox value="contGrade">{{ $t('matchTx.contGrade') }}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-row>
        <div class="row justify-content-start ml-2">
            <feather 
                @click="refreshMatchTx" 
                class="text-primary" 
                type="refresh-cw"  
                size="25" 
                v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
              </feather>  
                <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
                <span class="text-primary"> {{ asOf }} </span>   
            </div>
        <b-table
          sticky-header
          show-empty
          bordered
          responsive
          sort-icon-left
          stacked="md"
          :busy="isBusy"
          :sort-by.sync="sortByRels"
          :sort-desc.sync="sortDescRels"
          :sort-direction="sortDirectionRels"
          :filter="filterRels"
          :filter-included-fields="filterOnRels"
          :items="itemsRels"
          :fields="fieldsRels"
          :current-page="currentPageRels"
          :per-page="perPageRels"
          @filtered="onFilteredRels"      
          >
          <template #thead-top="">
            <b-tr>
              <b-th colspan="2"><span class="sr-only">mTxId and BkgId</span></b-th>
              <b-th variant="info" colspan="7" class="tableInfo">{{ $t('matchTx.contInfo') }}</b-th>
              <b-th colspan="1"><span class="sr-only">sealShip</span></b-th>
              <b-th variant="danger" colspan="2" class="tableInfo">{{ $t('matchTx.jobStatusMtx') }}</b-th>
              <b-th colspan="2"><span class="sr-only"></span></b-th>
              <b-th variant="success" colspan="4" class="tableInfo">{{ $t('release.header') }}</b-th>
              <b-th variant="primary" colspan="4" class="tableInfo">{{ $t('require.header') }}</b-th>
              <b-th variant="warning" colspan="3" class="tableInfo">{{ $t('matchTx.transportation') }}</b-th>
            </b-tr>
          </template>
          <template #cell(addressReqr)="row" >
            <b-button  size="sm" v-b-popover.hover.top="row.item.contReqrAddress" variant="outline-info">
                {{ $t('matchTx.reqr') }}
            </b-button>
          </template>
          <template #cell(addressRels)="row" >
            <b-button  size="sm" v-b-popover.hover.top="row.item.contRelsAddress" variant="outline-info">
                {{ $t('matchTx.rels') }}
            </b-button>
          </template>
          <template #cell(jbStatusRels)="row" >
            <b-button  size="sm" @click="openModalJbStatusRels(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('matchTx.jobStatusDetails')">
              {{ $t(`matchTx.${row.item.jbRels}`) }}
            </b-button>
          </template>
          <template #cell(transStatusRels)="row" >
            <b-button  size="sm" @click="openModalTransStatus(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('matchTx.transStatusDetails')">
              {{ $t(`matchTx.${row.item.transStatus}`) }}
            </b-button>
          </template>
          <template #cell(contImageRels)="row" >
            <b-button  size="sm" @click="openModalImageRels(row.item, row.index, $event.target )" v-b-popover.hover.top="`${$t('container.contId')} : ${row.item.contId}`">
              {{ row.item.contNo == 'Dummy' || row.item.contNo == 'dummy' || row.item.contNo == '' ? `${$t('container.dummy')}` : row.item.contNo }}
            </b-button>
          </template>
          <template #cell(transCompNameRels)="row" >
            <b-button  size="sm" @click="openModalTransCompRels(row.item, row.index, $event.target )">
                {{ row.item.transCompId }}
            </b-button>
          </template>
          <template #cell(actRels)="row" >
            <div>
              <b-button-group>
                <b-button class="mb-1" v-show="row.item.actRels.cancel" size="sm" variant="danger" @click="actReqrCancel(row.item , 1.3)" v-b-popover.hover.top="$t('matchTx.cancelMsg')" >
                  {{ $t('matchTx.cancel') }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actRels.accept" size="sm" variant="success" @click="actReqrAccept(row.item)" v-b-popover.hover.top="$t('matchTx.acceptMsg')">
                  {{ $t('matchTx.accept') }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actRels.reject" size="sm" variant="danger" @click="actReqrReject(row.item , 1.4)" v-b-popover.hover.top="$t('matchTx.rejectMsg')">
                  {{ $t('matchTx.reject') }}
                </b-button>                
              </b-button-group>
            </div>
            <div>
              <b-button-group>
                <b-button class="mb-1" v-show="row.item.actRels.eirRels" size="sm" variant="outline-info" @click="actEirRels(row.item)" v-b-popover.hover.top="$t('matchTx.eirRelsMsg')" >
                  {{ isGenerating && actEirAtLoc == 'rels'? $t('matchTx.eirRelsGentng') : $t('matchTx.eirRels')  }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actRels.dispRels" size="sm" variant="info" @click="actDispRels(row.item)" v-b-popover.hover.top="$t('matchTx.dispRelsMsg')" >
                  {{ $t('matchTx.dispRels') }}
                </b-button>
                <b-button class="mb-1" v-show="row.item.actRels.eirRecv" size="sm" variant="outline-info" @click="actEirRecv(row.item)" v-b-popover.hover.top="$t('matchTx.eirRecvMsg')" >
                  {{ isGenerating && actEirAtLoc == 'recv'? $t('matchTx.eirRecvGentng') : $t('matchTx.eirRecv')  }}
                </b-button>                
              </b-button-group>
            </div>
            <b-button class="mb-1" v-show="row.item.jbRels == 'shipsRej'" size="sm" variant="warning" @click="openModalViewShipsRejectRels(row.item, row.index, $event.target )">
              {{ $t('matchTx.viewShipsReject') }}
            </b-button>            
          </template>
          <template #empty>
              <h5>{{ $t('reuse.noRecord') }}</h5>
          </template>
        </b-table>
        <b-row>
          <div class="row col-sm-4 ">
            <b-col class="my-1 ml-3">
              <b-pagination
                v-model="currentPageRels"
                :total-rows="totalRowsRels"
                :per-page="perPageRels"
                align="fill"
                class="my-0"
              ></b-pagination>
            </b-col>   
            <b-col sm="3" md="6" class="my-1">
              <b-form-group
                :label="$t('require.perPage')"
                label-for="per-page-select"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0 "
              > 
                <b-form-select
                  id="per-page-select"
                  v-model="perPageRels"
                  :options="pageOptionsRels"
                ></b-form-select>
              </b-form-group>
            </b-col>          
          </div>
        </b-row>
      </div>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="`EIR${selected_mTxId}`"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="html2PdfNoInsp"
        >
          <section slot="pdf-content">
            <section class="pdf-item" >
              <div class="col-sm-12">
                  <h2  class="text-center text-primary mt-5 mb-4">{{ $t('matchTx.eirTitleNoInsp') }}</h2>
                  <div class="ml-2 d-flex flex-row justify-content-between">
                    <div class="text-center ml-5"><img :src="require('../../assets/images/conex-logo.png')" alt="conex"></div>                              
                    <div class="mr-5 mt-2">
                      <div class="row">
                          <h5 class="text-dark f-w-800 mx-2">{{ $t('matchTx.date') }} :</h5>
                          <span class="text-dark ml-1">{{ $moment().format(" DD/MMM/YYYY") }}</span>   
                      </div>
                      <div class="row">
                          <h5 class="text-dark f-w-800 mx-2">{{ $t('matchTx.refNo') }} :</h5>
                          <span class="text-dark ml-1">{{selected_mTxId}}-EIR</span>   
                      </div>                            
                    </div>
                  </div>                                      
              </div>                                  
              <div class="d-flex flex-row mt-5 col-sm-12">
                <div class="align-self-start  ml-4 border border-dark col-sm-6">
                  <b-card-group>
                    <b-card :img-src="require('../../assets/images/EIR_cont.png')" img-alt="Image" img-top></b-card>
                  </b-card-group>                      
                </div>
                <div class="align-self-strech border border-dark col-sm-5" >
                  <b-card-group class="d-flex flex-column justify-content-end">
                    <b-card >
                      <h5 class="text-dark" >{{ $t('matchTx.inspector') }} :</h5>
                      <h6 class="text-primary"> {{ selectedCompNameLocalInsp }}</h6>
                      <h6 class="text-primary"> {{ selectedContInspAddress }}</h6>  
                    </b-card>
                  </b-card-group>                    
                  <b-card-group>
                    <b-card >
                      <b-card-text>
                        <h5> {{ $t('matchTx.remark') }}</h5>
                        <h6 class="text-primary"> {{ remark }}</h6>
                      </b-card-text>
                    </b-card>
                  </b-card-group> 
                </div>
              </div>
              <div>
                <b-row class="my-3">
                  <b-col>
                    <h5 class="ml-5">{{$t('matchTx.contNoEir')}} : </h5> 
                    <span class="text-primary  ml-5"> {{ selectedContNo }}</span> 
                  </b-col>
                  <b-col>
                    <h5 class="ml-3">{{$t('matchTx.typeSize')}} : </h5> 
                    <span class="text-primary  ml-3"> {{selectedContType}} : {{ selectedContSize }} </span> 
                  </b-col>

                  <b-col>
                    <h5 class="ml-3">{{$t('matchTx.tareEir')}} : </h5> 
                    <span class="text-primary  ml-3"> {{selectedContTare}} </span> 
                  </b-col>
                </b-row>
                <b-row >
                  <b-col>
                    <h5 class="ml-5">{{$t('matchTx.bkgIdEir')}} : </h5> 
                    <span class="text-primary ml-5"> {{ selectedBkgId }}</span> 
                  </b-col>
                  <b-col>
                    <h5 class="ml-3">{{$t('matchTx.agentEir')}} : </h5> 
                    <span class="text-primary ml-3"> {{selectedAgent}} </span> 
                  </b-col>
                  <b-col>
                    <h5 class="ml-3">{{$t('matchTx.sealNoEir')}} : </h5> 
                    <span class="text-primary  ml-3"> {{selectedSealNo}} </span> 
                  </b-col>                  
                </b-row>
                <div class="divider mt-3 mx-5"> </div>   

                <b-card-group deck>
                  <b-card class="ml-4">
                    <h5 class="text-dark" >{{ $t('matchTx.compNameLocalRelsEir') }}</h5>
                    <h6 class="text-primary"> {{ selectedCompNameLocalRels }}</h6>
                    <h6 class="text-primary"> {{ selectedContRelsAddress }}</h6>        
                  </b-card>
                  <b-card>
                    <h5 class="text-dark" >{{ $t('matchTx.compNameLocalReqrEir') }}</h5>
                    <h6 class="text-primary"> {{ selectedCompNameLocalReqr }}</h6>
                    <h6 class="text-primary"> {{ selectedContReqrAddress }}</h6>        
                  </b-card>
                </b-card-group>

                <div class="divider mb-2 mx-5"> </div>
              </div>
              <div class="mt-3">
                <b-row >
                  <b-col>
                    <h4 class="ml-5">{{$t('matchTx.driver')}} : </h4> 
                    <div class="divider my-5 mx-5"> </div>
                  </b-col>
                  <b-col>
                    <h4 class="ml-3">{{$t('matchTx.tel')}} : </h4> 
                    <div class="divider my-5 mx-3"> </div>
                  </b-col>
                </b-row>
              </div>                                                                              
            </section>     
          </section>
        </vue-html2pdf>
      </div>
      <ReportEIR
        ref="pdfComponent"
        :actEirAtLoc="actEirAtLoc"
        :inspData = "inspData"
        :refNo = "selected_mTxId"
        :selectedItemInfo = "selectedReportEirItem"
        :transCompInfo = "transCompInspEIR"
        :contUrl = "urlx"
        @progress="handleProgress"
      >
      </ReportEIR>
    </b-container>
  </div>
</template>
<script>

import { getData,compInfo, shipReviewRemark, uaTxWallet, matchTxsRels,bkgIdListAgentGroup, makeMatchTxTrStep2, matchTxsReqr, updateStatus,updateActive, updateSealNo, sealNoListAgentGroup, updateMatchTx2StepN , xlsxRecvr, xlsxPropsr,xlsxInternal, xlsxTransfer, saveWithId, mergeObj } from "../../firebase"
import {exportXlsx ,getRandomInt} from "../../utilities/util" 
import {relsCost , reqrCost, reuCost, transferCost} from '../../constants/config'
import ReportEIR from "../../components/ReportEIR.vue"
  export default {
    name: 'matching',
        components : { ReportEIR},
    data() {
      return {
        urlx : [],
        progressValue : 0,
        isGenerating : false,
        selectedReportEirItem : '',
        asOf : this.$moment().format( "HH:mm,  DD-MM-YYYY"),
        selectedCompNameLocalRels: '',
        selectedContRelsAddress: '',
        selectedCompNameLocalReqr: '',        
        selectedContReqrAddress: '',
        selectedCompNameLocalInsp: '',        
        selectedContInspAddress: '',
        selectedContNo: '',
        selectedContSize: '',
        selectedContType: '',
        selectedContGrade: '',
        selectedContTare: '',
        selectedAgent: '',
        remark: '',
        compId : '',
        itemsReqr: [],
        itemsRels: [],
        jbStatusReqr:[],
        jbStatusRels:[],
        transStatus : [],
        trans: '',
        showDispRelsModal: false,
        showDispRecvModal: false,
        selectedDispItem: '',
        selectedEirItem : '',
        showEirModal: false,
        showSealNoModal: false,
        showUpdateSealNoModal: false,
        sealNos: [],
        selectedSealNo: '',
        currentSealNo: '',
        showTransferModal: false,
        bkgIds: [],
        selectedBkgId: '',
        selected_mTxId : '',       // for Reqr Transfer action charge
        selected_compIdReqr: '',   // for Reqr Transfer charge
        isBusy: false,        
        fieldsReqr: [
          { key: 'mTxId', label: this.$t('matchTx.mTxId'), sortable: true, variant: 'info',},  
          { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, variant: 'info',},     
          { key: 'contImageReqr', label: this.$t('matchTx.contNo'), sortable: true, variant: 'info'},        
          { key: 'detTS', label: this.$t('matchTx.dt'), sortable: true,  variant: 'info',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }},
          { key: 'contType', label: this.$t('matchTx.type'), sortable: true,  variant: 'info'},
          { key: 'contSize', label: this.$t('matchTx.size'), sortable: true,  variant: 'info'},
          { key: 'contGrade', label: this.$t('matchTx.gradeTh'), sortable: true, variant: 'info' },
          { key: 'maxGross', label: this.$t('matchTx.maxGross'), sortable: true,  variant: 'info'},
          { key: 'tare', label: this.$t('matchTx.tare'), sortable: true,  variant: 'info'},
          { key: 'sealNo', label: this.$t('matchTx.sealNo'), sortable: true, variant: 'info',},
          { key: 'agent', label: this.$t('matchTx.ships'), sortable: true, variant: 'info',},                
          { key: 'msReqr', label: this.$t('matchTx.matching'), sortable: false, variant: 'danger',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'jbStatusReqr', label: this.$t('matchTx.jobStatus'), sortable: true, variant: 'danger',}, 
          { key: 'shoreStatus', label: this.$t('matchTx.shore'), sortable: true, variant: 'danger',
            formatter: value => {
            return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'actReqr', label: this.$t('matchTx.actions'), variant: 'secondary', thStyle:{width:'220px'} },          
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, variant: 'secondary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},           
          { key: 'compNameLocalRels', label: this.$t('matchTx.compNameLocalRels'), sortable: true, variant: 'success'},                
          { key: 'jobTypeRels', label: this.$t('matchTx.transport'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }},  
          { key: 'sRelsTS', label: this.$t('matchTx.startRels'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }},    
          { key: 'addressRels', label: this.$t('matchTx.address'), sortable: false, variant: 'success'},
          { key: 'compNameLocalReqr', label: this.$t('matchTx.compNameLocalReqr'), sortable: true, variant: 'primary'},                
          { key: 'jobTypeReqr', label: this.$t('matchTx.transport'), sortable: true, variant: 'primary',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }},
          { key: 'sReqrTS', label: this.$t('matchTx.startReqr'), sortable: true, variant: 'primary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }}, 
          { key: 'addressReqr', label: this.$t('matchTx.address'), sortable: false,variant: 'primary' },                        
          { key: 'distance', label: this.$t('matchTx.distance'), sortable: true, variant: 'warning' },           
          { key: 'transCompNameReqr', label: this.$t('matchTx.transComp'), sortable: true,variant: 'warning' },      
          { key: 'transStatusReqr', label: this.$t('matchTx.transStatus'), sortable: true, variant: 'danger',}, 
        ],
        fieldsRels: [
          { key: 'mTxId', label: this.$t('matchTx.mTxId'), sortable: true,  variant: 'info'},  
          { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true,  variant: 'info'},     
          { key: 'contImageRels', label: this.$t('matchTx.contNo'),sortable: true, variant: 'info'},          
          { key: 'detTS', label: this.$t('matchTx.dt'), sortable: true,  variant: 'info',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }},
          { key: 'contType', label: this.$t('matchTx.type'), sortable: true,  variant: 'info'},
          { key: 'contSize', label: this.$t('matchTx.size'), sortable: true,  variant: 'info'},
          { key: 'contGrade', label: this.$t('matchTx.gradeTh'), sortable: true,  variant: 'info'},
          { key: 'maxGross', label: this.$t('matchTx.maxGross'), sortable: true,  variant: 'info'},
          { key: 'tare', label: this.$t('matchTx.tare'), sortable: true,  variant: 'info'},
          { key: 'agent', label: this.$t('matchTx.ships'), sortable: true,  variant: 'info'},                
          { key: 'msRels', label: this.$t('matchTx.matching'), sortable: false,variant: 'danger',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'jbStatusRels', label: this.$t('matchTx.jobStatus'), sortable: true, variant: 'danger',}, 
          { key: 'actRels', label: this.$t('matchTx.actions'), variant: 'secondary',  thStyle:{width:'220px'}},          
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, variant: 'secondary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},             
          { key: 'compNameLocalRels', label: this.$t('matchTx.compNameLocalRels'), sortable: true, variant: 'success',},                
          { key: 'jobTypeRels', label: this.$t('matchTx.transport'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'sRelsTS', label: this.$t('matchTx.startRels'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }}, 
          { key: 'addressRels', label: this.$t('matchTx.address'), sortable: false, variant: 'success'},              
          { key: 'compNameLocalReqr', label: this.$t('matchTx.compNameLocalReqr'), sortable: true, variant: 'primary'},                
          { key: 'jobTypeReqr', label: this.$t('matchTx.transport'), sortable: true,variant: 'primary' ,
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'sReqrTS', label: this.$t('matchTx.startReqr'), sortable: true, variant: 'primary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }}, 
          { key: 'addressReqr', label: this.$t('matchTx.address'), sortable: false,variant: 'primary' },             
          { key: 'distance', label: this.$t('matchTx.distance'), sortable: true,  variant: 'warning'},              
          { key: 'transCompNameRels', label: this.$t('matchTx.transComp'), sortable: true, variant: 'warning'},
          { key: 'transStatusRels', label: this.$t('matchTx.transStatus'), sortable: true, variant: 'danger',}, 
        ],
        totalRowsReqr: 1,
        currentPageReqr: 1,
        perPageReqr: 10,
        pageOptionsReqr: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortByReqr: 'timestamp',
        sortDescReqr: true,
        sortDirectionReqr: 'asc',
        filterReqr: null,
        filterOnReqr: [],
        actReqrAttachSealModal: {
          id: 'reqrAttachSeal-modal',
          title: this.$t('matchTx.attachSeal'),
        },
        actReqrUpdateSealModal: {
          id: 'reqrUpdateSeal-modal',
          title: this.$t('matchTx.updateSeal'),
        },
        actReqrTransferModal: {
          id: 'reqrTransfer-modal',
          title: this.$t('matchTx.transfer'),
        },
        totalRowsRels: 1,
        currentPageRels: 1,
        perPageRels: 10,
        pageOptionsRels: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortByRels: 'timestamp',
        sortDescRels: true,
        sortDirectionRels: 'asc',
        filterRels: null,
        filterOnRels: [],
        imageUriModalReqr: [],
        modalTitleReqr : '',
        modalContIdReqr: '',
        imageUriModalRels: [],
        modalTitleRels : '',
        modalContIdRels: '',
        shipsRejectRemarkRels : '',
        shipsRejectRemarkReqr : '',
        transCompInfoRels : '',
        transCompInfoReqr : '',
        inspData : '',
        // urlQty : 0,
        // url_1 : '',
        // url_2 : '',
        // url_3 : '',
        // url_4 : '',
        // url_5 : '',
        // url_6 : '',
        // url_7 : '',
        // url_8 : '',
        // url_9 : '',
        // url_10 : '',
        transCompInspEIR : '',
        actEirAtLoc : '',
        showShoreModal : false,
        selectedShoreItem : '', 
        destPort: '',
        cargoDesc: '',
        cargoWeight: null,
        cargoOwner: '',
      }
    },
    computed: {
      htmlToPdfOptions(){
        return {
          margin: 0,
          filename: `EIR${this.selected_mTxId}`,
          image: {
            type: 'jpg', 
            quality: 0.98
          },
          enableLinks: false,
          html2canvas: {
            scale: 1,
            useCORS: true
          },
        }
      },
      sortOptionsReqr() {
        // Create an options list from our fields
        return this.fieldsReqr
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      sortOptionsRels() {
        // Create an options list from our fields
        return this.fieldsRels
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
    
    mounted() {
      this.compId= localStorage.getItem("compId")
      matchTxsReqr(this.compId , (res)=>{
        this.itemsReqr = res 
        this.totalRowsReqr = res.length
        // console.log(`[matchTxReqr => ${JSON.stringify(res , null , 2)}]`)
      })
      matchTxsRels(this.compId , (res)=>{
        this.itemsRels = res
        this.totalRowsRels = res.length
        // console.log(`[matchTxRels => ${JSON.stringify(res , null , 2)}]`)
      })
    },
    methods: {
      onFilteredReqr(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRowsReqr = filteredItems.length
        this.currentPageReqr = 1
      },
      onFilteredRels(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRowsRels = filteredItems.length
        this.currentPageRels = 1
      },
      async refreshMatchTx() {
        this.isBusy = true
        this.selectedSealNo = ""
        this.selected_mTxId = ""
        this.selected_compIdReqr = ""
        await matchTxsReqr(this.compId , (res)=>{
          this.itemsReqr = res
          this.totalRowsReqr = res.length
          this.isBusy = false
        })
         await matchTxsRels(this.compId , (res)=>{
          this.itemsRels = res
          this.totalRowsRels = res.length
        })
        this.asOf = this.$moment().format( "HH:mm,  DD-MM-YYYY")
      },
      async actReqrCancel(item ,stepNo) {
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmCancelMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          cancelVariant: 'warning',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              // updateStatus('Release', item.relsId, 'Release')// reverse status to "Release"
              item.txSearcher == "Release" ? updateStatus('Require', item.reqrId, 'Require') : updateStatus('Release', item.relsId, 'Release')// return  status of Poster for recycle.
              item.txSearcher == "Release" ? updateActive( 'Container', item.contId , true ): null
              await updateMatchTx2StepN('MatchTx',item.mTxId , stepNo).then(async()=>{
                // no reuse case at this step
                let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000, 90000)}`
                if (item.txSearcher == "Release") {
                  await uaTxWallet(relsCost, item.compIdRels, slipId, "auto", "refund", "cancel release in match",item.mTxId )   // Rels Refund  
                } else {
                  await uaTxWallet(reqrCost, item.compIdReqr, slipId, "auto", "refund", "cancel require in match",item.mTxId )  // Reqr Refund
                }
                await this.refreshMatchTx()
              })

            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Cancel : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },
      actReqrReject(item , stepNo) {
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmRejectMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          cancelVariant: 'warning',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              // updateStatus('Release', item.relsId, 'Release')// reverse status to "Release"
              item.txSearcher == "Release" ? updateStatus('Require', item.reqrId, 'Require') : updateStatus('Release', item.relsId, 'Release')// return  status of Poster for recycle.
              item.txSearcher == "Release" ? updateActive( 'Container',item.contId , true ): null
              // item.txSearcher == "Release" ? updateStatus('Release', item.relsId, 'Release'): null
              await updateMatchTx2StepN( 'MatchTx',item.mTxId , stepNo).then(async()=>{
                // no reuse case at this step
                let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000, 90000)}`
                if (item.txSearcher == "Release") {
                  await uaTxWallet(relsCost, item.compIdRels, slipId, "auto", "refund","reject release in match", item.mTxId )   // Rels Refund  
                } else {
                  await uaTxWallet(reqrCost, item.compIdReqr, slipId, "auto", "refund", "reject require in match",item.mTxId )  // Reqr Refund
                }
                await this.refreshMatchTx()
              })
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Reject-Require : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },     
      
      actReqrAccept(item) {
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmAcceptMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          cancelVariant: 'warning',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async (value) => {
            if (value) {
              await updateMatchTx2StepN('MatchTx',item.mTxId , 2).then(async()=>{
                await this.refreshMatchTx()
              })
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Accept-Require : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },
      async actDispRels(item) {
        await getData( 'EIR' , 'contId' , item.contId, async(res)=>{
          if (res.length != 0) { 
            await getData('Cont6Images' , 'contId', item.contId , (contImg)=>{
              if (contImg.length != 0) {
                this.selectedDispItem = item
                this.selectedEirItem = res[0]
                this.showDispRelsModal = true
              } else{
                this.$toasted.show( this.$t('matchTx.noImageShoreRels'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});                  
              }
            })
          } else {
            this.$toasted.show( this.$t('matchTx.noInspShoreRels'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});  
          }
        })
      },
      async actDispRecv(item) {
        await getData( 'EirRecv' , 'contId' , item.contId, async(res)=>{
          if (res.length != 0) { 
            await getData('Cont6ImagesRecv' , 'contId', item.contId , (contImg)=>{
              if (contImg.length != 0) {
                this.selectedDispItem = item
                this.selectedEirItem = res[0]
                this.showDispRecvModal = true
              } else{
                this.$toasted.show( this.$t('matchTx.noImageShoreRecv'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});                  
              }
            })
          } else {
            this.$toasted.show( this.$t('matchTx.noInspShoreRecv'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});  
          }
        })
      },
      dispRelsReject(){
        this.dispReject(4.1)
      },      
      dispRelsAccept(){
        this.dispAccept(5)

      },
      dispRecvReject(){
        this.dispReject(5.1)
      },      
      dispRecvAccept(){
        this.dispAccept(6)

      },
      disp_NO(){
        this.showDispRelsModal = false
        this.showDispRecvModal = false
        this.selectedEirItem = ''
        this.selectedDispItem = ''
      },
      dispAccept( stepNo ){
        const mTxId = this.selectedDispItem.mTxId
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmDispAcceptMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          cancelVariant: 'warning',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async (value) => {
            if (value) {
              await updateMatchTx2StepN('MatchTx', mTxId , stepNo).then(async()=>{
                await this.refreshMatchTx()
                this.showDispRecvModal = false
                this.showDispRelsModal = false
                this.selectedEirtem = ''
                this.selectedDispItem = ''
              })
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Accept-Disposal: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },
      dispReject( stepNo){
        const mTxId = this.selectedDispItem.mTxId
        const compIdRels =  this.selectedDispItem.compIdRels
        const compIdReqr =  this.selectedDispItem.compIdReqr
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmDispRejectMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          cancelVariant: 'warning',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async (value) => {
            if (value) {
              await updateMatchTx2StepN('MatchTx', mTxId , stepNo).then(async()=>{
                let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000, 90000)}`
                await uaTxWallet(relsCost, compIdRels, `${slipId}-RELS`, "auto", "refund","Disposal reject @Release", mTxId )   // Disp Refund  
                await uaTxWallet(reqrCost, compIdReqr, `${slipId}-REQR`, "auto", "refund", "Disposal reject @Receive", mTxId )  // Disp Refund                
                await this.refreshMatchTx()
                this.showDispRecvModal = false
                this.showDispRelsModal = false
                this.selectedEirItem = ''
                this.selectedDispItem = ''
                this.$toasted.show( this.$t('matchTx.refundSuccess'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 8000});        
              })
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Reject-Disposal : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },   
      async actShoreCancel(item) {
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmShoreCancelMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          cancelVariant: 'warning',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              await updateStatus( 'Shore' , item.mTxId , 'cancel')
              await mergeObj('MatchTx', item.mTxId ,{
              shoreStatus : 'cancel',
              timestamp: Date.parse(new Date())
            })  
            await this.refreshMatchTx()
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Shore Cancel : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },
      async actShore(item) {
        this.selectedShoreItem = item
        this.showShoreModal = true
      },
      clickShore_NO(){
        this.selectedShoreItem = ''
        this.showShoreModal = false
      },
      async clickShore_OK(){
        let msg = 'completed'
        if (this.cargoDesc ===''){
            msg = 'matchTx.addCargoDesc'
        } else if (this.cargoOwner ===''){
            msg = 'matchTx.addCargoOwner'                        
          } else if (this.destPort ==='') {
            msg = 'matchTx.addDestPort'
        } else if (this.cargoWeight <= 0){
            msg = 'matchTx.addCargoWeight'
        }  
        if (msg === 'completed'){
          let payload = {
              shoreId : this.selectedShoreItem.mTxId,   // mTxId
              agent : this.selectedShoreItem.agent,
              destPort : this.destPort,
              cargoDesc : this.cargoDesc,
              cargoWeight: this.cargoWeight,
              cargoOwner: this.cargoOwner,            
              compId : this.compId,
              contId : this.selectedShoreItem.contId,
              contNo : this.selectedShoreItem.contNo,
              contSize : this.selectedShoreItem.contSize,
              contType : this.selectedShoreItem.contType,
              contGrade : this.selectedShoreItem.contGrade,
              tare : this.selectedShoreItem.tare,
              sealNo : this.selectedShoreItem.sealNo,
              bkgId : this.selectedShoreItem.bkgId,
              compIdReqr : this.selectedShoreItem.compIdReqr,
              compNameLocalReqr : this.selectedShoreItem.compNameLocalReqr,
              status : 'waitAccept',
              timestamp: Date.parse(new Date()),
          }
          await saveWithId('Shore', this.selectedShoreItem.mTxId, payload).then(async()=>{
            await updateMatchTx2StepN('MatchTx', this.selectedShoreItem.mTxId , 7)
            this.$toasted.show(this.$t('matchTx.successShore'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 8000});  
            this.refreshShoreData()
            await this.refreshMatchTx()
          })              
        }else{
            this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }  
      },
      refreshShoreData(){
        this.selectedShoreItem = ''
        this.destPort = ''
        this.cargoDesc = ''
        this.cargoWeight = 0
        this.cargoOwner = ''
        this.showShoreModal = false
      },
      startDownload() {
        this.isGenerating = true
        this.progressValue = 0
        // สั่งให้ Sub-component เริ่มทำงาน
        this.$refs.pdfComponent.generate()
      },
      handleProgress(val) {
        this.progressValue = val
        // เมื่อครบ 100% ให้รีเซ็ตสถานะ
        if (val === 100) {
          setTimeout(() => {
            this.isGenerating = false
          }, 1000)
        }
      },
      async actEirRels(item){
        await this.actEir(item, 'EIR', 'Cont6Images')
        this.actEirAtLoc = 'rels'
      },
      async actEirRecv(item){
        await this.actEir(item, 'EirRecv', 'Cont6ImagesRecv')
        this.actEirAtLoc = 'recv'
      },
      async actEir(item ,  eirColl , imgColl) {
        this.selectedReportEirItem = item
        this.selected_mTxId = item.mTxId
        await getData( eirColl , 'contId' , item.contId, async(res)=>{
          if (res.length != 0 && res[0].sumResult != '') {
            this.inspData = res[0]
            await getData(imgColl , 'contId', item.contId , (contImg)=>{
              if (contImg.length != 0) {
                this.urlx = contImg[0].url6   // for Components : ReportEIR
                // console.log(`[this.urlx] =>  ${JSON.stringify(this.urlx, null, 2)}`)
              } else {
                if (imgColl == 'Cont6Images' ) {
                this.$toasted.show( this.$t('matchTx.noImageShoreRels'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000})                   
                } else {
                this.$toasted.show( this.$t('matchTx.noImageShoreRecv'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000})                   
                }
              }
            })
            await getData('Company', 'compId', res[0].compId , (comp)=>{
              if (comp.length != 0) {
                this.transCompInspEIR = comp[0]
                this.startDownload()
              }
            })              
          } else {
            this.remark = `${this.$t('matchTx.grade')} : ${item.contGrade}`
            this.showEirModal=true            
          }
        })
      },
      clickEir_Issue(){
        let msg = 'completed'
            if (this.selectedCompNameLocalRels ===''){
                msg = this.$t('matchTx.compNameLocalRelsMsg')
            } else if (this.selectedContRelsAddress ===''){
                msg = this.$t('matchTx.contRelsAddressMsg')                
            } else if (this.selectedCompNameLocalReqr ===''){
                msg = this.$t('matchTx.compNameLocalReqrMsg')
            } else if (this.selectedContReqrAddress ===''){
                msg = this.$t('matchTx.contReqrAddressMsg')
            }  
            if (msg === 'completed'){
                this.$refs.html2PdfNoInsp.generatePdf()
                this.showEirModal= false
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
      },
      clickEir_NO(){
        this.selected_mTxId = ''
        this.selectedCompNameLocalRels= ''
        this.selectedCompNameLocalReqr= ''
        this.selectedContRelsAddress= ''
        this.selectedContReqrAddress= ''
        this.selectedContNo= ''
        this.selectedContSize= ''
        this.selectedContType= ''
        this.selectedContGrade= ''
        this.selectedContTare= ''
        this.selectedAgent= ''
        this.selectedBkgId= ''
        this.selectedSealNo= ''
        this.showEirModal= false
      },
      async actReqrAttachSeal(item) {
        this.selected_mTxId = item.mTxId
        await sealNoListAgentGroup(this.compId, item.agent, (res)=>{
          this.sealNos = res
          this.showSealNoModal=true
        })
      },
      async clickAttachSeal_OK(){
        if (!this.selectedSealNo ) {
          this.$toasted.show( this.$t('matchTx.noSeal'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
        } else {
          await updateMatchTx2StepN('MatchTx', this.selected_mTxId , 4 , this.selectedSealNo)
          .then(async()=>{
            await updateActive('Seal' , this.selectedSealNo , false)
            this.showSealNoModal= false
            this.refreshMatchTx()
          })
        }
      },
      async actReqrUpdateSeal(item) {
        console.log(`[actReqrAttachSeal], item =>  ${JSON.stringify(item, null, 2)}`)
        this.selected_mTxId = item.mTxId
        this.currentSealNo = item.sealNo
        await sealNoListAgentGroup(this.compId, item.agent, (res)=>{
          this.sealNos = res
          this.showUpdateSealNoModal=true
        })
      },
      async clickUpdateSeal_OK(){
        if (!this.selectedSealNo ) {
          this.$toasted.show( this.$t('matchTx.noSeal'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
        } else {
          await updateSealNo("MatchTx", this.selected_mTxId, this.selectedSealNo)
          .then(async()=>{
            await updateActive('Seal' , this.selectedSealNo , false)
            await updateActive('Seal' , this.currentSealNo , true)
            this.showUpdateSealNoModal= false
            this.refreshMatchTx()
          })
        }
      },
      actReqrTerminate(item){
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmTerminateMsg'), {
          title: item.txSearcher != "Reuse" ? this.$t('matchTx.plsConfirmTerminate') : this.$t('matchTx.plsConfirm') ,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              if (item.txSearcher == "Reuse") {
                await updateMatchTx2StepN('MatchTx',item.mTxId , 4.2).then(async()=>{
                  let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000, 90000)}`
                  updateStatus('Reuse', item.reqrId, 'Terminated')
                  updateActive( 'Container', item.contId, true )
                  item.sealNo ? await updateActive('Seal' , item.sealNo , true) : null
                  await uaTxWallet(reuCost / 2, item.compIdReqr, slipId, "auto", "refund", "terminate reuse in match", item.mTxId)
                  await this.refreshMatchTx()
                })
              } else {
                let nowTS = new Date().valueOf()
                let earlyDetTS = item.detTS - nowTS
                if (earlyDetTS < 259200000 || item.detTS <= nowTS ) {    // 3 days early
                  this.$toasted.show( `${this.$t('matchTx.early3DaysTerminateMsg')}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
                } else {
                  item.txSearcher == "Require" ? updateStatus('Release', item.relsId, 'Release') : null
                  // no refund to Reqr (should be receiver but terminate )
                  await updateMatchTx2StepN('MatchTx',item.mTxId , 4.2).then(async()=>{
                    item.sealNo ? await updateActive('Seal' , item.sealNo , true) : null
                    await this.refreshMatchTx()
                  })
                }
              }
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Terminate : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },

      async actReqrTransfer(item) {
        console.log(`[actReqrTransfer], item =>  ${JSON.stringify(item, null, 2)}`)
        this.selected_mTxId = item.mTxId
        this.selected_compIdReqr = item.compIdReqr
        await bkgIdListAgentGroup(this.compId, item.agent, item.bkgId,(res)=>{
          this.bkgIds = res
          this.showTransferModal=true
        })
      },
      async clickBkgId_OK(){
        if (!this.selectedBkgId ) {
          this.$toasted.show( this.$t('matchTx.noBkgId'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
        } else {
          let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000, 90000)}`
          await makeMatchTxTrStep2(this.selected_mTxId , this.selectedBkgId).then(async()=>{   // make new MatchTx - Transfer for ship approval (stepNo: 2), jbReqr/Rels: waitApprovalTr, txSearcher: Transfer
            await updateMatchTx2StepN('MatchTx', this.selected_mTxId ,this.selectedBkgId, 6.1)  // step up current MatchTx to step 6.1 as status: cancel , jbReqr: transferred ,txSearcher: Transfer
            await uaTxWallet(transferCost * -1, this.selected_compIdReqr, slipId, "auto", "expense", "rights transfer", this.selected_mTxId)
            this.showTransferModal= false
            this.refreshMatchTx()    
          })
        }
      },
      async openModalJbStatusReqr(item, index, button) {
        await getData( 'jbStatusReqr' , 'id' , item.mTxId, (res)=>{
            this.jbStatusReqr = res.sort((a,b)=>
              b.timestamp - a.timestamp
            )
            this.$root.$emit('bv::show::modal', "jbStatusModalReqr" , button)
        })
      },
      resetInfoModalJbReqr() {
        this.jbStatusReqr = []
      },
      async openModalJbStatusRels(item, index, button) {
        await getData( 'jbStatusRels' , 'id' , item.mTxId, (res)=>{
            this.jbStatusRels = res.sort((a,b)=>
              b.timestamp - a.timestamp
            )
            this.$root.$emit('bv::show::modal', "jbStatusModalRels" , button)
        })
      },
      resetInfoModalJbRels() {
        this.jbStatusRels = []
      },
      async openModalTransStatus(item, index, button) {
          await getData( 'transStatus' , 'id' , item.mTxId, async(res)=>{
            if (res.length != 0) {
              this.transStatus = res.sort((a,b)=>
              b.timestamp - a.timestamp
            )
            }        
            await getData( 'Transport' , 'transId' , item.mTxId, (trans)=>{
            if (trans.length != 0) {
            this.trans = trans[0]                
            }
          })            
        }).then(()=>{
            this.$root.$emit('bv::show::modal', "transStatusModal" , button)          
        })
      },
      resetInfoModalTransStatus() {
        this.transStatus = []
        this.trans = ''
      },
      async openModalImageReqr(item, index, button) {
        await getData( 'Container' , 'contId' , item.contId, (res)=>{
            this.imageUriModalReqr = res[0].url6
            this.modalTitleReqr = `${this.$t('container.contNo')} : ${res[0].contNo}`
            this.modalContIdReqr = res[0].contId
            this.$root.$emit('bv::show::modal', "contModalReqr" , button)
        })
      },
      resetInfoModalReqr() {
        this.modalTitleReqr = ''
        this.modalContIdReqr = ''
        this.imageUriModalReqr = []
      },
      async openModalImageRels(item, index, button) {
        await getData( 'Container', 'contId', item.contId ,(res)=>{
          this.imageUriModalRels = res[0].url6
          this.modalTitleRels = `${this.$t('container.contNo')} : ${res[0].contNo}`
          this.modalContIdRels = res[0].contId
          this.$root.$emit('bv::show::modal', "contModalRels" , button)          
        })
      },
      resetInfoModalRels() {
        this.modalTitleRels = ''
        this.imageUriModalRels = []
        this.modalContIdRels = ''
      },      
      async openModalTransCompRels(item, index, button) {
        await compInfo(item.transCompId , (res)=>{
          this.transCompInfoRels = res
        })
        this.$root.$emit('bv::show::modal', "transCompModalRels" , button)
      },
      resetInfoModalTransCompRels() {
        this.transCompInfoRels = ''
      },      
      async openModalTransCompReqr(item, index, button) {
        await compInfo(item.transCompId , (res)=>{
          this.transCompInfoReqr = res
        })  
        this.$root.$emit('bv::show::modal', "transCompModalReqr" , button)
      },
      resetInfoModalTransCompReqr() {
        this.transCompInfoReqr = ''
      },
      async openModalViewShipsRejectRels(item, index, button) {
        await shipReviewRemark(item.mTxId , (res)=>{
          this.shipsRejectRemarkRels = res
        })  
        this.$root.$emit('bv::show::modal', "viewShipsRejectModalRels" , button)
      },
      resetInfoModalShipsRejectRels() {
        this.shipsRejectRemarkRels = ''
      },

      async openModalViewShipsRejectReqr(item, index, button) {
        // console.log(`openModalViewShipsRejectReqr => ${JSON.stringify(item , null , 2)}`)
        await shipReviewRemark(item.mTxId , (res)=>{
          this.shipsRejectRemarkReqr = res
        })  
        this.$root.$emit('bv::show::modal', "viewShipsRejectModalReqr" , button)
      },

      resetInfoModalShipsRejectReqr() {
        this.shipsRejectRemarkReqr = ''
      },

      async exportItems (compId , startAt, endAt, cb ){
        await xlsxRecvr( compId, startAt , endAt, async(reqr)=>{
          await xlsxPropsr( compId, startAt , endAt, async(rels)=>{
            let i = reqr.concat(rels)
            await xlsxInternal( compId, startAt , endAt, async(reu)=>{
              i = i.concat(reu)
              await xlsxTransfer(compId, startAt, endAt, (trn)=>{
                i = i.concat(trn)
                cb(i)
              })
            })
          })
        })
      },
      async back7days(){
        let endAt = Date.parse(new Date())
        let startAt =  endAt - 604800000 
        let name = `conex_${this.$moment(startAt).format("YYYY-MM-DD")}_${this.$moment(endAt).format("YYYY-MM-DD")}`
        try {
          this.exportItems(this.compId, startAt, endAt , (res)=>{
            exportXlsx(res, name)
            // console.log("[exportItems] res =>"+ JSON.stringify(res, null , 2)) 
          })
        } catch (error) {
          this.$toasted.show(`${this.$t('matchTx.errExportData')}: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }
      },
      async back30days(){
        let endAt = Date.parse(new Date())
        let startAt =  endAt - 18446400000 
        let name = `conex_${this.$moment(startAt).format("YYYY-MM-DD")}_${this.$moment(endAt).format("YYYY-MM-DD")}`
        try {
          this.exportItems(this.compId, startAt, endAt , (res)=>{
            exportXlsx(res, name)
            // console.log("[exportItems] res =>"+ JSON.stringify(res, null , 2)) 
          })
        } catch (error) {
          this.$toasted.show(`${this.$t('matchTx.errExportData')}: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }
      },
      async inYear(){
        let endAt = Date.parse(new Date())
        let startAt = Date.parse(new Date("2024/01/01"))
        let name = `conex_${this.$moment(startAt).format("YYYY-MM-DD")}_${this.$moment(endAt).format("YYYY-MM-DD")}`
        try {
          this.exportItems(this.compId, startAt, endAt , (res)=>{
            exportXlsx(res, name)
            // console.log("[exportItems] res =>"+ JSON.stringify(res, null , 2)) 
          })
        } catch (error) {
          this.$toasted.show(`${this.$t('matchTx.errExportData')}: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }
      },
      scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
  }
</script>
<style scoped>
/* 1. Base styling for all items */
.my-loop-item {
  padding: 5px;
  margin-bottom: 2px;
  border: 1px solid #ccc;
}

/* 2. Styling specifically for the first item */
/* This targets the <div> with class 'my-loop-item' that is also the first child of its parent */
.my-loop-item:first-child {
  background: linear-gradient(135deg, white, pink);
  font-weight: bold;
  font-size: 16px;
  border: 2px solid #00bcd4;
}
  .divider {
    height: 1px;
    background-color: #0f0f0f;
    margin:5px
  }
  .display-image {
    width: 100%;
    height: 450px;
    object-fit: scale-down;
    border-radius: 8px;
    background-color: #f5f5f5;
  }
 .gradient-gy {
   background: linear-gradient(135deg, green, yellow);
 }
 .gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-wp {
   background: linear-gradient(135deg, white, pink);
 }
 .gradient-wb {
   background: linear-gradient(45deg, white, blue)
 }
 /* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN OFF */
  background-color: #ccc; /* Example: Gray when off */
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

/* Change background color of the slider when checked (ON state) */
input:checked + .slider {
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN ON */
  background-color: #2196F3; /* Example: Blue when on */
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

.display-image {
  width: 100%;
  height: 450px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}

  .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}
.tableInfo {
  text-align: center;
  color: #021001;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>